<template>
    <MessageOpenSection
      :hidden="messages_selection.count > 0"
      :messages_view="messages_view"
      :webmail_view ="webmail_view"
      :viewport_controller="viewport_controller"
      :folder_id="folder_id"
    />
</template>

<script setup>
  import { defineProps }    from 'vue';
  import MessageOpenSection from './Sections/MessageOpenSection.vue';

  const props = defineProps({
    messages_view      : {},
    webmail_view       : {},
    viewport_controller: {},
    folder_id          : {},
    messages_selection : {},
  });
</script>
